<!--  -->
<template>
  <div class="SearchBox">
      <input type="text"placeholder="请输入关键字搜索" @keyup.enter="searchinfo" v-model="keyword">
      <span class="btn" @click="searchinfo" >搜索</span>
  </div>
</template>

<script>
export default {
  name: "SearchBox",
  components: {},
  data() {
      return {
          keyword:''
      };
  },
  methods: {
    searchinfo(){
        // 修改父组件当前页的值
        this.$emit('serchevent', this.keyword)
    }
  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.SearchBox{
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    background-color: #f1f5fc;
    height: 50px;
    border-radius: 4px;
    input{
        width: 290px;
        height: 36px;
        background-color: white;
        border: none;
        border-radius: 4px;
        padding: 8px 10px !important;
        outline: none !important;
        font-size: 14px;
    }
    input::placeholder{
        color:darkgray !important;
    }
    .btn{
        display: block;
        width: 80px;
        height: 36px;
        font-size: 14px;
        background-color: #409EFF;
        color: white;
        cursor: pointer;
        border-radius: 4px;
    }
}
</style>